var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  fill: "none",
  viewBox: "0 0 22 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#176F69",
  fillRule: "evenodd",
  d: "M11 22.556c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11m0-1.2c5.412 0 9.8-4.388 9.8-9.8s-4.388-9.8-9.8-9.8-9.8 4.388-9.8 9.8 4.388 9.8 9.8 9.8",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#176F69",
  d: "M11 18.056a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11.6 13.956a.6.6 0 0 1-1.2 0v-8.8a.6.6 0 1 1 1.2 0z"
})));
export { SvgInfoIcon as ReactComponent };